import unescape from 'lodash/unescape';

type JSONreviver = (this: any, key: string, value: any) => any;

const JSONParse = (text: string, reviver?: JSONreviver) => {
  try {
    if (Number.isInteger(parseInt(text))) {
      throw Error("JSONparse 'text' parameter is not string");
    }

    return {
      value: JSON.parse(unescape(text), reviver),
    };
  } catch (ex) {
    return {
      error: ex,
    };
  }
};

export default JSONParse;
